import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallanPartner from "./component";
import { logoutUser, markUnauthorized, setMobile } from "../../configuration/actions";
import { setRegNo } from "../my-challans/actions";
import { fetchChallanLandingPageData, fetchOrderData, fetchRegNumberList } from "../e-challan/actions";

const mapStateToProps = ({
    eChallan: { cmsContent, isSSR, regNumberList, recentTransaction },
    user: { isLoggedIn, secureToken, mobile }
}) => ({
    mobile,
    cmsContent,
    isSSR,
    regNumberList,
    recentTransaction,
    isLoggedIn,
    secureToken
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setRegNoConnect: setRegNo,
    setMobileConnect: setMobile,
    logoutConnect: logoutUser,
    markUnauthorizedConnect: markUnauthorized,
    fetchRegNumberListConnect: fetchRegNumberList,
    fetchOrderDataConnect: fetchOrderData,
    fetchChallanLandingPageDataConnect: fetchChallanLandingPageData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EChallanPartner);
